module.exports = __webpack_public_path__ + "static/img/thumb_2.16da240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_2.jpg
// module id = l6ha
// module chunks = 0